module.exports = "https://cdn-skillquest.mathletics.com/app/164/assets/images/27225403faa7cb949eeb6d1f3611edb7.gif";